import * as React from "react";
import {
  TextField,
  NumberField,
  ImageField,
  SimpleShowLayout,
  Show,
  DateField,
  TopToolbar,
  EditButton,
  BooleanField,
  useTranslate,
} from "react-admin";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const TelegramProductShowActions = () => {
  const navigate = useNavigate();
  const translate = useTranslate();

  return (
    <TopToolbar sx={{ justifyContent: 'space-between' }}>
      <Button
        onClick={() => navigate(-1)}
        startIcon={<ArrowBackIcon />}
        sx={{ mr: 'auto' }}
      >
        {translate('app.back')}
      </Button>
      <EditButton />
    </TopToolbar>
  );
};

export const TelegramProductShow: React.FC = () => {
  const translate = useTranslate();

  return (
  <Show actions={<TelegramProductShowActions />}>
    <SimpleShowLayout>
      <ImageField
        source="image"
        label={translate('resources.telegram-products.fields.image')}
        sx={{ "& img": { maxWidth: 260, borderRadius: 2 } }}
      />
      <TextField source="title" />
      <TextField source="description" label={translate('resources.telegram-products.fields.description')} />
      <NumberField
        source="price"
        label={translate('resources.telegram-products.fields.price')}
        options={{ style: "currency", currency: "CZK" }}
      />
      <BooleanField source="postedInTg" label={translate('resources.telegram-products.fields.postedInTelegram')} />
      <DateField source="createdAt" label={translate('resources.telegram-products.fields.createdAt')} />
      <DateField source="updatedAt" label={translate('resources.telegram-products.fields.updatedAt')} />
    </SimpleShowLayout>
  </Show>
  );
};
